import { Node } from "@tiptap/pm/model";

export function isDirectChild(doc: Node, node: Node): boolean {
  let isFirstLevel = true;
  doc.descendants((child, _, parent) => {
    if (node.eq(child)) {
      isFirstLevel = parent?.type.name === "doc";
      return false; // stops traversal in case node is found
    } else return true;
  });
  return isFirstLevel;
}
